import { render, staticRenderFns } from "./MindsetAddReportDialog.vue?vue&type=template&id=06733b91&"
import script from "./MindsetAddReportDialog.vue?vue&type=script&lang=ts&"
export * from "./MindsetAddReportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports